var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      backgroundColor: "#f6f6f7",
      padding: 12
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "5t7ldzcona",
    d: "M4.71 5.494c-.21 0-.41-.081-.557-.228L.23 1.344C-.077 1.037-.077.54.23.231c.308-.308.806-.308 1.113 0L4.71 3.603 8.074.24c.31-.267.775-.249 1.065.04.29.29.307.754.04 1.065L5.26 5.266c-.147.145-.344.226-.55.228z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1497.000000, -416.000000) translate(1151.000000, 335.000000) translate(17.000000, 70.000000) translate(332.000000, 16.000000) scale(-1, 1) translate(-332.000000, -16.000000) translate(316.000000, 0.000000) translate(15.584077, 15.584077) scale(-1, 1) rotate(-90.000000) translate(-15.584077, -15.584077) translate(-0.415923, -0.415923) translate(10.969017, 13.184077)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cjng1f56zb",
    fill: "#fff",
    transform: "scale(0.6)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5t7ldzcona"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#5t7ldzcona"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7F7692",
    mask: "url(#cjng1f56zb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H9.6V6H0z",
    transform: "translate(-0.184940, -0.090824)"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f1991d870492451f0d954bb1a3afef15.svg";
export { ForwardRef as ReactComponent };